/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import { Box, Skeleton } from '@mui/material';
import { SnippetsSection } from '../Snippets/SnippetsSection';

type SkeletonLoaderProps = {
	isLoading: boolean;
	children: ReactNode;
	number: number;
	sectionTitle: string;
};

export function SkeletonLoader( { children, isLoading, number, sectionTitle }: SkeletonLoaderProps ): ReactNode {
	return (
		<div>
			<Box sx={ { display: !isLoading ? 'none' : 'inherit' } } data-testid={ 'skeleton-loader' }>
				<SnippetsSection headerCharacter={ number } title={ sectionTitle }>
					<Skeleton height={ 50 } sx={ { opacity: '0.3' } } variant={ 'rounded' } width={ '100%' }/>
				</SnippetsSection>
			</Box>
			<Box sx={ { display: isLoading ? 'none' : 'inherit' } } data-testid={ 'skeleton-loader-content' }>
				{ children }
			</Box>
		</div>
	);
}
